import { useEffect } from 'react';

/**
 * Per-page browser-tab titles, so history and open tabs identify each Jody
 * page ("Lisbon to Porto · Jody" instead of ten identical entries).
 *
 * Pass the page-specific part only; the " · Jody" suffix is appended here.
 * Pass undefined while the page's data is still loading — the title updates
 * when it arrives. The default (index.html) title is restored on unmount so
 * pages that don't set a title yet keep the generic one.
 */
const DEFAULT_TITLE = 'Jody · Journeys Over Destinations'; // public/index.html's <title>

export function useDocumentTitle(title: string | undefined | null) {
  useEffect(() => {
    if (title) document.title = `${title} · Jody`;
    return () => {
      document.title = DEFAULT_TITLE;
    };
  }, [title]);
}
